import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取业务绑定的sop推送联系人
export function queryJobSopReceiver(params) {
  return request({
    url: URL.booking.queryJobSopReceiver,
    method: 'get',
    params
  })
}

// 保存sop推送人
export function saveSopEmailReceiver(data) {
  return request({
    url: URL.booking.saveSopEmailReceiver,
    method: 'post',
    data
  })
}
